export default __webpack_public_path__ + "static/media/Background_00179.19514ede.png";